import { PageLayout } from "@/components/layout/PageLayout";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqItems = [
  {
    category: "General",
    questions: [
      {
        question: "Ce este OptiRO.ai?",
        answer: "OptiRO.ai este o platformă de analiză SEO + GEO (Generative Engine Optimization) creată special pentru piața din România, cu focus pe eCommerce și site-uri care vor vizibilitate atât în Google, cât și în motoarele AI moderne (ChatGPT, Gemini, Perplexity, AI Overview Google).\n\nÎn versiunea actuală (MVP), OptiRO.ai îți oferă o scanare rapidă a site-ului și un raport trimis pe email, cu scoruri și observații despre claritatea site-ului, autoritatea percepută și oportunități de îmbunătățire.\n\nÎn versiunea completă (lansare estimată la jumătatea anului 2026), OptiRO.ai va merge mai departe de analiză: va propune optimizări concrete și va permite implementarea lor controlată, cu aprobarea ta.",
      },
      {
        question: "Ce înseamnă GEO (Generative Engine Optimization)?",
        answer: "GEO (Generative Engine Optimization) este optimizarea unui site pentru a fi inteles, citat si recomandat de sistemele AI care genereaza raspunsuri, precum ChatGPT, Gemini, Perplexity sau AI Overview Google.\n\nDaca SEO clasic te ajuta sa apari in rezultatele Google, GEO urmareste ca brandul tau sa apara in raspunsurile generate de AI atunci cand utilizatorii pun intrebari de tipul 'ce recomanzi?' sau 'care este cea mai buna solutie?'.\n\nGEO se bazeaza pe semnale precum claritatea semantica, consistenta tematica, autoritatea perceputa si validarea externa (mentionari/backlink-uri relevante).",
      },
      {
        question: "Cum funcționează analiza site-ului?",
        answer: "Analiza OptiRO.ai (în MVP) urmează un flux simplu:\n\n1. Introduci URL-ul site-ului tău în formularul de scanare.\n2. Sistemul scanează elemente publice ale site-ului (structură, conținut vizibil, semnale SEO de bază).\n3. OptiRO.ai generează un rezumat pe loc (teaser) și un raport mai detaliat care poate fi trimis pe email.\n4. Dacă alegi să lași emailul, primești raportul complet și te înscrii în waitlist/newsletter pentru lansare.\n\nImportant: în MVP nu se fac modificări pe site-ul tău și nu cerem acces la CMS.",
      },
    ],
  },
  {
    category: "Pricing & Waitlist",
    questions: [
      {
        question: "Cât costă OptiRO.ai?",
        answer: "În acest moment (MVP), scanarea și raportul sunt gratuite.\n\nLa lansarea versiunii complete (estimativ la jumătatea lui 2026), OptiRO.ai va avea planuri plătite.\n\nPentru cei înscriși în newsletter/waitlist, pregătim o ofertă de lansare: Plan Start – 20 lei în prima lună (preț standard ulterior: 100 lei/lună).\n\nDetaliile finale ale planurilor vor fi comunicate prin email înainte de lansare.",
      },
      {
        question: "Ce primesc dacă mă înscriu pe Waitlist?",
        answer: "Prin înscrierea pe waitlist:\n\n• Primești raportul complet pe email (unde este disponibil)\n• Primești prioritate la acces când se lansează versiunea completă\n• Primești notificări despre lansare și update-uri importante\n• Primești oferta de lansare (ex: prima lună la 20 lei, în limita promoției anunțate)\n\nWaitlist-ul este modul prin care ne asigurăm că utilizatorii interesați au acces mai rapid și condiții mai bune la start.",
      },
      {
        question: "Când va fi disponibilă versiunea completă?",
        answer: "Ținta de lansare pentru versiunea completă OptiRO.ai este în jurul jumătății anului 2026.\n\nPe măsură ce ne apropiem de lansare, utilizatorii înscriși în waitlist vor primi:\n• data exactă\n• detalii despre planuri\n• oferta promoțională și pașii de activare",
      },
    ],
  },
  {
    category: "Tehnic",
    questions: [
      {
        question: "Ce tip de site-uri pot fi analizate?",
        answer: "OptiRO.ai poate analiza majoritatea site-urilor publice, inclusiv:\n\n• Magazine online (eCommerce)\n• Site-uri de prezentare\n• Site-uri de servicii locale\n• Bloguri și platforme de conținut\n\nDacă un site blochează scanarea (ex: are protecții stricte, cere autentificare sau blochează crawler-e), analiza poate fi limitată.",
      },
      {
        question: "Cât durează o analiză completă?",
        answer: "În general, scanarea durează între 30 de secunde și ~2 minute, în funcție de:\n\n• Viteza site-ului analizat\n• Mărimea și complexitatea paginilor\n• Limitările tehnice impuse de serverul site-ului",
      },
      {
        question: "Cum măsurați scorul GEO?",
        answer: "Scorul GEO este o estimare orientativa a vizibilitatii si AI-readiness a site-ului. El este calculat pe baza mai multor semnale, de exemplu:\n\n• Claritatea tematica (cat de usor se intelege despre ce e brandul)\n• Structura semantica (organizarea continutului pentru extragere si sintetizare)\n• Consistenta (daca site-ul sustine coerent aceeasi nisa)\n• Semnale de autoritate/validare externa (in functie de datele disponibile)\n• Capacitatea paginilor de a raspunde complet la intrebari specifice\n\nScorul nu este standard Google si nu este afiliat cu platforme AI - este o metrica interna OptiRO.ai, menita sa te ajute sa compari si sa prioritizezi.",
      },
      {
        question: "Datele mele sunt în siguranță?",
        answer: "Da. În MVP:\n\n• Nu cerem parole\n• Nu cerem acces la conturi\n• Nu accesăm panoul de administrare al site-ului\n• Analizăm doar informații publice (ce e vizibil pe web)\n\nEmail-ul și URL-ul sunt folosite pentru generarea raportului și comunicarea legată de lansare și ofertă.\n\nDacă vrei ștergerea datelor sau dezabonare, ne poți scrie oricând la: contactoptiro@gmail.com",
      },
    ],
  },
  {
    category: "Suport",
    questions: [
      {
        question: "Cum pot contacta echipa de suport?",
        answer: "Ne poți contacta direct prin email la:\n📧 contactoptiro@gmail.com\n\nÎți recomandăm să incluzi în mesaj:\n• URL-ul analizat\n• Emailul folosit pentru raport\n• Ce problemă ai întâmpinat (și un screenshot, dacă ai)",
      },
      {
        question: "Oferiți consultanță personalizată?",
        answer: "Da, oferim consultanță în cazurile în care un business vrea:\n\n• Interpretarea raportului\n• Prioritizare clară a acțiunilor\n• Recomandări adaptate nișei și competiției\n\nConsultanța nu este obligatorie pentru utilizarea OptiRO.ai și se va face în funcție de disponibilitate (mai ales până la lansarea completă).",
      },
    ],
  },
];

const FAQ = () => {
  return (
    <PageLayout>
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-foreground mb-4">Întrebări Frecvente</h1>
          <p className="text-xl text-muted-foreground">
            Răspunsuri la cele mai comune întrebări despre OptiRO.ai
          </p>
        </div>

        <div className="space-y-8">
          {faqItems.map((category, categoryIndex) => (
            <div key={categoryIndex}>
              <h2 className="text-2xl font-semibold text-foreground mb-4 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary" />
                {category.category}
              </h2>
              <Accordion type="single" collapsible className="w-full">
                {category.questions.map((item, itemIndex) => (
                  <AccordionItem key={itemIndex} value={`${categoryIndex}-${itemIndex}`}>
                    <AccordionTrigger className="text-left hover:text-primary">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground leading-relaxed whitespace-pre-line">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center p-8 bg-muted/50 rounded-2xl">
          <h3 className="text-xl font-semibold text-foreground mb-2">Nu ai găsit răspunsul?</h3>
          <p className="text-muted-foreground mb-4">
            Contactează-ne la <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a> și îți vom răspunde cât mai curând posibil.
          </p>
          <a href="/support" className="text-primary font-medium hover:underline">
            Mergi la pagina de Suport →
          </a>
        </div>
      </div>
    </PageLayout>
  );
};

export default FAQ;
